import { ActionBar, CountryDialog, DeleteDialog } from './components';
import { useDialogState, useRowSelection } from './hooks';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { useCountry } from '@/hooks/queries/useCountry';
import { getDataTableColumns } from './cols-definition';

export default function DanhMucQuocGia() {
  const { countries, isLoading, addCountry, updateCountry, deleteCountry } = useCountry();
  const { selectedObj, selectedRowIndex, handleRowClick, clearSelection } = useRowSelection();
  const {
    showAddDialog,
    showEditDialog,
    showDeleteDialog,
    showWatchDialog,
    isCopyMode,

    openAddDialog,
    closeAddDialog,
    openEditDialog,
    closeEditDialog,
    openDeleteDialog,
    closeDeleteDialog,
    openWatchDialog,
    closeWatchDialog,

    handleAddButtonClick,
    handleEditButtonClick,
    handleDeleteButtonClick,
    handleCopyButtonClick
  } = useDialogState(clearSelection);

  const tables = [
    {
      name: 'Tất cả',
      rows: countries,
      columns: getDataTableColumns()
    }
  ];

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {(showAddDialog || showEditDialog) && (
        <CountryDialog
          open={showAddDialog || showEditDialog}
          mode={showEditDialog ? 'edit' : 'add'}
          initialData={
            selectedObj && showEditDialog
              ? {
                  ma_qg: selectedObj.ma_qg,
                  ten_qg: selectedObj.ten_qg,
                  ten_qg2: selectedObj.ten_qg2,
                  status: parseInt(String(selectedObj.status))
                }
              : selectedObj && showAddDialog && isCopyMode
                ? {
                    ma_qg: selectedObj.ma_qg,
                    ten_qg: selectedObj.ten_qg,
                    ten_qg2: selectedObj.ten_qg2,
                    status: parseInt(String(selectedObj.status))
                  }
                : undefined
          }
          onClose={showEditDialog ? closeEditDialog : closeAddDialog}
          selectedObj={showEditDialog ? selectedObj : null}
          addCountry={addCountry}
          updateCountry={updateCountry}
        />
      )}

      {showDeleteDialog && (
        <DeleteDialog
          open={showDeleteDialog}
          onClose={closeDeleteDialog}
          selectedObj={selectedObj}
          deleteCountry={deleteCountry}
          clearSelection={clearSelection}
        />
      )}

      {showWatchDialog && selectedObj && (
        <CountryDialog
          open={showWatchDialog}
          mode='view'
          initialData={{
            ma_qg: selectedObj.ma_qg,
            ten_qg: selectedObj.ten_qg,
            ten_qg2: selectedObj.ten_qg2,
            status: parseInt(String(selectedObj.status))
          }}
          onClose={closeWatchDialog}
          selectedObj={selectedObj}
          addCountry={addCountry}
          updateCountry={updateCountry}
          onAddButtonClick={handleAddButtonClick}
          onEditButtonClick={handleEditButtonClick}
          onDeleteButtonClick={handleDeleteButtonClick}
          onCopyButtonClick={handleCopyButtonClick}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={openAddDialog}
          onEditIconClick={() => selectedObj && openEditDialog()}
          onDeleteIconClick={() => selectedObj && openDeleteDialog()}
          onCopyIconClick={() => selectedObj && handleCopyButtonClick()}
          onWatchIconClick={() => selectedObj && openWatchDialog()}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>
    </div>
  );
}
